import { render, staticRenderFns } from "./PolicyInitiativeDetails.vue?vue&type=template&id=62507b65&scoped=true&"
import script from "./PolicyInitiativeDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyInitiativeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62507b65",
  null
  
)

export default component.exports